/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { oxygenYield } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const YIELD_OFFERS = 'yield.offers';
export const YIELD_DEPOSITED = 'yield.deposited';
export const YIELD_RECEIVED = 'yield.received';
export const GET_TICKER_MARKET_RATES = 'yield.ticker';
export const YIELD_DEPOSIT_DETAILS = 'yield.deposit.details';

queryClient.setQueryDefaults(YIELD_OFFERS, {
  queryFn: () => oxygenYield.offers(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(YIELD_DEPOSITED, {
  queryFn: () => oxygenYield.deposited(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(YIELD_RECEIVED, {
  queryFn: () => oxygenYield.received(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(GET_TICKER_MARKET_RATES, {
  queryFn: async ({ queryKey }) => {
    const data = await oxygenYield.ticker(queryKey[1]);
    return data;
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(YIELD_DEPOSIT_DETAILS, {
  queryFn: ({ queryKey }) => {
    const data = oxygenYield.depositDetails(queryKey[1]);
    return data;
  },
  onError: (error) => {
    handleError(error);
  },
});
